type Props = {
  children: React.ReactNode;
};

export const ModelCommentReplyFormContainer: React.FC<Props> = ({ children }: Props) => {
  return <div className="px-[14px] py-2 text-3xl">{children}</div>;
};
